import { HeaderText as SharedHeaderText } from '../../components/atomic/text/header_text/HeaderText';
import headerTextImg from './header_text.png';
import './HeaderText.css';

/** From Figma — «ПОЛУЧЕН СТИКЕР!», top 242.9688 / left 252.6387. */
export function HeaderText() {
  return (
    <SharedHeaderText
      className="sticker-reward-header-text"
      src={headerTextImg}
      alt="Получен стикер!"
    />
  );
}
